// Class archive exports contain guardian contact fields only.
export const csvCell = (value) => {
  const text = String(value ?? '');
  const safe = /^[\s]*[=+\-@]/.test(text) ? "'" + text : text;
  return '"' + safe.replace(/"/g, '""') + '"';
};

export const parentContactsCsv = (contacts) => {
  const rows = [['Parent / Guardian', 'Email', 'Classes', 'Terms', 'Recorded Newsletter Consent']];
  contacts.forEach(row => rows.push([
    row.parent_name || '', row.email, (row.classes || []).join('; '),
    (row.terms || []).join('; '), row.newsletter_consent || 'unknown',
  ]));
  return '\uFEFF' + rows.map(row => row.map(csvCell).join(',')).join('\r\n');
};

export const suggestArchiveTerm = (program) => {
  if (program.current_term_label || program.term_of) return program.current_term_label || program.term_of;
  const match = /^(\d{4})-(\d{2})-/.exec(program.startDate || '');
  if (!match) return '';
  const month = Number(match[2]);
  const season = month >= 5 && month <= 8 ? 'Summer' : month >= 9 && month <= 11 ? 'Fall' : month <= 4 && month >= 2 ? 'Spring' : 'Winter';
  return season + ' ' + match[1];
};
